import React from 'react';
import { MonthlyCalculationDetail } from '../../pages/admin/marketer-consultant/MonthlyCalculationDetail';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';
import { fmtMoney, fmtNum } from '../../pages/admin/marketer-consultant/monthlyCalculationUtils';
import {
  stdModalHeaderBg, stdModalHeaderIconBox, stdModalHeaderTitle, stdModalHeaderSub, stdModalCloseBtn,
} from '../../pages/admin/adminlayout/designStandard';

const S = {
  overlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 2000,
    background: 'rgba(15,23,42,0.42)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: 'max(10px, env(safe-area-inset-top)) 12px max(10px, env(safe-area-inset-bottom))',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
  },
  modal: {
    width: 'min(980px, calc(100vw - 24px))',
    maxHeight: 'min(90vh, calc(100dvh - 20px))',
    marginTop: 10,
    overflow: 'hidden',
    border: '1px solid var(--border)',
    borderRadius: 14,
    background: 'var(--bg-card)',
    boxShadow: '0 22px 70px rgba(15,23,42,0.28)',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  // 모달 헤더 검정 표준 (2026-08-31 통일) — 스티키 유지, 밴드가 구분선을 대신한다
  head: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    background: stdModalHeaderBg,
  },
  headText: { minWidth: 0, flex: '1 1 auto' },
  title: { ...stdModalHeaderTitle, margin: 0 },
  sub: { ...stdModalHeaderSub, lineHeight: 1.45 },
  close: stdModalCloseBtn,
  body: { padding: 12, overflowY: 'auto', overflowX: 'hidden', minWidth: 0, boxSizing: 'border-box' },
};

export function ConsultantChargeDetailModal({ charge, onClose, summaryScope = 'settlement' }) {
  const snapshot = charge?.snapshot || {};
  const row = charge?.row || snapshot.row || null;
  const assignment = charge?.assignment || snapshot.assignment || null;
  const year = charge?.year || snapshot.period?.year || row?.year;
  const month = charge?.month || snapshot.period?.month || row?.month;
  useBodyScrollLock(Boolean(charge && row));

  if (!charge || !row) return null;

  return (
    <div style={S.overlay} onMouseDown={onClose}>
      <div style={S.modal} onMouseDown={(event) => event.stopPropagation()}>
        <div style={S.head}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0, flex: '1 1 auto' }}>
            <div style={stdModalHeaderIconBox} aria-hidden="true">💰</div>
          <div style={S.headText}>
            <h3 style={S.title}>
              {charge.consultantName || row.consultantName} {month}월 1:1급여 계산내역
            </h3>
            <div style={S.sub}>
              {charge.marketerName || row.marketerName} 정산서 반영 · 확정 스냅샷 기준 · {fmtMoney(charge.chargeAmount || row.chargeAmount)} · {fmtNum(charge.weightedCount || row.weightedCount)}장
            </div>
          </div>
          </div>
          <button type="button" style={S.close} onClick={onClose} aria-label="닫기">×</button>
        </div>
        <div style={S.body}>
          <MonthlyCalculationDetail
            row={row}
            assignment={assignment}
            year={year}
            month={month}
            readOnlyRules
            summaryScope={summaryScope}
            summaryItemId={charge.id}
          />
        </div>
      </div>
    </div>
  );
}
